import http from './http'; // ✅ use same instance

class ValidateUserService {
  static validate(username: string) {
    return http.post('/auth/validate-user', { username });
  }
}

export default ValidateUserService;
